import { Button, type IconComponent } from '@taskall/react';
import * as React from 'react';
import { cx } from './cx';

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: IconComponent;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cx('flex flex-col items-center justify-center gap-2 px-6 py-12 text-center', className)}>
      {Icon ? (
        <span className="mb-2 grid size-12 place-items-center rounded-full bg-[var(--taskall-brand-soft)] text-[var(--taskall-brand)]">
          <Icon size={22} aria-hidden="true" />
        </span>
      ) : null}
      <p className="font-display text-base font-semibold text-[var(--taskall-content-primary)]">{title}</p>
      {description ? <p className="max-w-md text-sm text-[var(--taskall-content-secondary)]">{description}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}

/** Estado de erro com botão "Tentar novamente" — evita tela branca. */
export function ErrorState({
  title = 'Não foi possível carregar os dados',
  description,
  onRetry,
  className,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div role="alert" className={cx('flex flex-col items-center gap-2 px-6 py-10 text-center', className)}>
      <p className="font-display text-base font-semibold text-[var(--taskall-status-error)]">{title}</p>
      {description ? <p className="max-w-md text-sm text-[var(--taskall-content-secondary)]">{description}</p> : null}
      {onRetry ? (
        <Button className="mt-3" size="small" visualStyle="outline" onClick={onRetry}>
          Tentar novamente
        </Button>
      ) : null}
    </div>
  );
}
